exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body{min-height:100vh}#app,body{margin:0;padding:0}#app{font-size:12px;font-family:sans-serif;width:100%;height:100vh}", ""]);

